import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthRoute } from 'src/models/routes.model';
import { DeviceService } from 'src/services/device.service';
import { OauthLoginService } from 'src/services/oauth-login.service';

@Injectable({
  providedIn: 'root'
})
export class OauthRedirectLoginGuard  {
  private router = inject(Router);
  private oauthLoginService = inject(OauthLoginService);
  private deviceService = inject(DeviceService);

  private accessKey: string | null = null;

  public canActivate(): boolean {
    if(this.urlContainBcasToken() && this.accessKey) {
      this.oauthLoginService.logIn(this.accessKey);
      return true;
    } else {
      if (!this.deviceService.isNativePlatform) {
        this.router.navigate([`/${AuthRoute.LOGIN}`]);
      }
      return false;
    }
  }

  private urlContainBcasToken(): boolean {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    if(params['code']) {
      this.accessKey = params['code'];
      return true;
    }

    return false;
  }

  public inAppBrowserAssignKeyAndNavigate(key: string): void {
    this.accessKey = key;
    this.oauthLoginService.logIn(this.accessKey);
  }

}
